import AltruPayTerminals from "components/Collections/AltruPayTerminals";
import AmmoReadyInventory from "components/Collections/AmmoReadyInventory";
import Certificates from "components/Collections/Certificates";
import CertificateTransactions from "components/Collections/CertificateTransactions";
import Consignments from "components/Collections/Consignments";
import Services from "components/Collections/Services";
import CheckoutServicesPicker from "components/Collections/CheckoutServicesPicker";
import Customers from "components/Collections/Customers";
import CustomersLogs from "components/Collections/CustomersLogs";
import FFLLookup from "components/Collections/FFLLookup";
import GrossRevenueReport from "components/Collections/GrossRevenueReport";
import Inventories from "components/Collections/Inventories";
import Invoices from "components/Collections/Invoices";
import InventoryLedgers from "components/Collections/InventoryLedgers";
import InventoryReport from "components/Collections/InventoryReport";
import Layaways from "components/Collections/Layaways";
import LayawayEntries from "components/Collections/LayawayEntries";
import LayawayItems from "components/Collections/LayawayItems";
import LayawayPayments from "components/Collections/LayawayPayments";
import LayawayPaymentRefunds from "components/Collections/LayawayPaymentRefunds";
import LayawayProducts from "components/Collections/LayawayProducts";
import Kiosks from "components/Collections/Kiosks";
import LayawayServices from "components/Collections/LayawayServices";
import InvoicePayments from "components/Collections/InvoicePayments";
import WorkOrders from "components/Collections/WorkOrders";
import WorkOrderEntries from "components/Collections/WorkOrderEntries";
import WorkOrderItems from "components/Collections/WorkOrderItems";
import WorkOrderPayments from "components/Collections/WorkOrderPayments";
import WorkOrderProducts from "components/Collections/WorkOrderProducts";
import WorkOrderServices from "components/Collections/WorkOrderServices";
import Locations from "components/Collections/Locations";
import Memberships from "components/Collections/Memberships";
import NetMarginsReport from "components/Collections/NetMarginsReport"
import NetProfitsReport from "components/Collections/NetProfitsReport";
import Products from "components/Collections/Products";
import SalesReport from "components/Collections/SalesReport";
import SalesByCategoryReport from "components/Collections/SalesByCategoryReport";
import EmployeeSalesReport from "components/Collections/EmployeeSalesReport";
import LayawayReport from "components/Collections/LayawayReport";
import WorkOrderReport from "components/Collections/WorkOrderReport";
import InvoiceReport from "components/Collections/InvoiceReport";
import RegisterLedgers from "components/Collections/RegisterLedgers";
import Registers from "components/Collections/Registers";
import Reports from "components/Collections/Reports";
import SalesTaxReports from "components/Collections/SalesTaxReports";
import TaxableBreakdownReports from "components/Collections/TaxableBreakdownReports";
import Sessions from "components/Collections/Sessions";
import SkuClasses from "components/Collections/SkuClasses";
import Skus from "components/Collections/Skus";
import TradeIns from "components/Collections/TradeIns";
import TransactionEntries from "components/Collections/TransactionEntries"
import TransactionRefunds from "components/Collections/TransactionRefunds";
import Transactions from "components/Collections/Transactions";
import Users from "components/Collections/Users";
import YearEndReport from "components/Collections/YearEndReports";

const Collections = {
	AltruPayTerminals: AltruPayTerminals,
	AmmoReadyInventory: AmmoReadyInventory,
	Certificates: Certificates,
	CertificateTransactions: CertificateTransactions,
	Consignments: Consignments,
	Services: Services,
	CheckoutServicesPicker: CheckoutServicesPicker,
	Customers: Customers,
	CustomersLogs: CustomersLogs,
	FFLLookup: FFLLookup,
	GrossRevenueReports: GrossRevenueReport,
	Inventories: Inventories,
	Invoices: Invoices,
	InventoryLedgers: InventoryLedgers,
	InventoryReport: InventoryReport,
	Layaways:Layaways,
	LayawayEntries:LayawayEntries,
	LayawayItems:LayawayItems,
	LayawayPayments: LayawayPayments,
	LayawayProducts: LayawayProducts,
	Kiosks: Kiosks,
	LayawayServices: LayawayServices,
	InvoicePayments:InvoicePayments,
	WorkOrders:WorkOrders,
	WorkOrderEntries:WorkOrderEntries,
	WorkOrderItems:WorkOrderItems,
	WorkOrderPayments: WorkOrderPayments,
	WorkOrderProducts: WorkOrderProducts,
	WorkOrderServices: WorkOrderServices,
	Locations: Locations,
	Memberships: Memberships,
	NetMarginsReport: NetMarginsReport,
	NetProfitsReport: NetProfitsReport,
	Products: Products,
	SalesReport: SalesReport,
	SalesByCategoryReport: SalesByCategoryReport,
	EmployeeSalesReport: EmployeeSalesReport,
	LayawayReport: LayawayReport,
	WorkOrderReport: WorkOrderReport,
	InvoiceReport: InvoiceReport,
	Reports: Reports,
	RegisterLedgers: RegisterLedgers,
	Registers: Registers,
	SalesTaxReports: SalesTaxReports,
	TaxableBreakdownReports: TaxableBreakdownReports,
	Sessions: Sessions,
	SkuClasses: SkuClasses,
	Skus: Skus,
	TradeIns: TradeIns,
	TransactionEntries: TransactionEntries,
	TransactionRefunds:TransactionRefunds,
	LayawayPaymentRefunds: LayawayPaymentRefunds,
	Transactions: Transactions,
	Users: Users,
	YearEndReport: YearEndReport

};

export default Collections;
